/* ============
 * Services. External services functionality support
 * ============
 */

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
